import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import AppointmentPage from "./pages/AppointmentPage";
import PatientsPage from "./pages/PatientsPage";
import PaymentPage from "./pages/PaymentPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import { AppointmentConfirmation } from "./pages/AppoinmentConfirmation/AppoinmentConfirmation";

const Routes = () => {
  return (
    <Switch>
      <Route path={"/:orgName"} exact>
        <Home />
      </Route>
      <Route path={"/c/cita"} exact>
        <AppointmentPage />
      </Route>

      <Route path={"/c/pacientes"} exact>
        <PatientsPage />
      </Route>

      <Route path={"/c/pago"} exact>
        <PaymentPage />
      </Route>

      <Route path={"/c/confirmarCita"} exact>
        <AppointmentConfirmation />
      </Route>
      <Route path={"/c/confirmacion/:id"}>
        <ConfirmationPage />
      </Route>
    </Switch>
  );
};

export default Routes;
